<template>
  <NoteModal @dismiss="$emit('dismiss')">
    <p class="font_blue">・{{ $t('oilTreatmentNote.title') }}</p>
    <p v-html="$t('oilTreatmentNote.description')"></p>
  </NoteModal>
</template>

<script>
import NoteModal from '@/components/lib/NoteModal.vue'

export default {
  components: { NoteModal },
}
</script>
